import { useFormikContext } from 'formik'
import { FormStatus } from '@ztechapps/webui.form'
import { Alert } from '@ztechapps/webui.util'
import { jsonStringify } from '@ztechapps/common.utils'
import React from 'react'
import type { DeleteRequestFormData } from './DeleteRequestForm'

export const SubmissionAlert = ({ error }: any) => {
  const formikContext = useFormikContext<DeleteRequestFormData>()

  if (formikContext?.status === FormStatus.error || error) {
    return (
      <Alert type="danger">
        <h2>Server error occurred</h2>
        <p>Please try again later.</p>
        <small>{jsonStringify(error)}</small>
      </Alert>
    )
  }

  if (formikContext?.status === FormStatus.success) {
    return (
      <Alert type="success">
        <h2>Success!</h2>
        <p>We will contact you as soon as possible to confirm the deletion of your data.</p>
      </Alert>
    )
  }
}
